import React from "react";
import { InputText } from "primereact/inputtext";
import { AppPageHeader } from "components/shared/AppPageHeader";
import { AppButton } from "components/shared/AppButton";
import { SearchInputContainer } from "styles/components/usersList.styles";

interface UsersHeaderProps {
  title: string;
  onAddUser?: () => void;
  addButtonText?: string;
  searchValue?: string;
  onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchPlaceholder?: string;
}

const UsersHeader: React.FC<UsersHeaderProps> = ({
  title,
  onAddUser,
  addButtonText = "+ Add User",
  searchValue = "",
  onSearchChange,
  searchPlaceholder = "Search users...",
}) => {
  return (
    <AppPageHeader title={title}>
      {onSearchChange && (
        <SearchInputContainer>
          <span className="p-input-icon-left">
            <i className="pi pi-search" style={{ marginLeft: 10 }} />
            <InputText
              value={searchValue}
              onChange={onSearchChange}
              placeholder={searchPlaceholder}
              aria-label={searchPlaceholder}
            />
          </span>
        </SearchInputContainer>
      )}
      {onAddUser && (
        <AppButton type="button" onClick={onAddUser}>
          {addButtonText}
        </AppButton>
      )}
    </AppPageHeader>
  );
};

export default UsersHeader;
